<template>
  <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" min-width="auto">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="value"
        :label="label"
        :prepend-icon="icon"
        readonly
        hide-details
        outlined
        dense
        clearable
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="value" @input="menu = false"></v-date-picker>
  </v-menu>
</template>

<script>

export default {
  props: {
    modelValue: String,
    label: String,
    icon: String
  },
  data() {
    return {
      menu: false
    }
  },
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  }
};
</script>
